import { getCreateWithIAReferenceImageLimit } from "./createWithIAReferenceImages";

export const resolveCreateWithIAMediaType = (formMediaType) => ({
  mediaType: formMediaType === "carousel" ? "image" : formMediaType,
  isCarousel: formMediaType === "carousel",
});

export const normalizeMatchedProductImageUrls = (data) => {
  if (!Array.isArray(data)) {
    return [];
  }

  return data
    .filter((url) => typeof url === "string" && url.trim())
    .map((url) => url.trim());
};

export const getMaxMatchedProductImages = ({ mediaType }) =>
  getCreateWithIAReferenceImageLimit({ mediaType });

export const buildMatchCreativeProductPayload = ({
  formValues,
  campaignID,
  initialValues = {},
}) => {
  const { mediaType, isCarousel } = resolveCreateWithIAMediaType(
    formValues.mediaType
  );

  return {
    mediaType,
    isCarousel,
    campaignID: campaignID || initialValues.campaignID || null,
    campaignContext: initialValues.campaignContext || "",
    prompt: formValues.prompt || "",
    language: formValues.language,
    platform: formValues.platform || "",
    videoType: formValues.videoType,
    imagesUrl: formValues.imagesUrl || [],
    referenceAdUrl: formValues.referenceAdUrl || "",
  };
};

export const applyMatchedProductAsset = ({
  response,
  getValues,
  setValue,
  onProductMatched = () => {},
}) => {
  const matchedUrls = normalizeMatchedProductImageUrls(response?.data);
  if (!response?.ok || matchedUrls.length === 0) {
    return;
  }

  const imagesAfterMatch = getValues("imagesUrl") || [];
  if (imagesAfterMatch.length > 0) return;

  if (getValues("referenceAdUrl")?.trim()) return;

  const mediaType = getValues("mediaType");
  const maxImages = getMaxMatchedProductImages({ mediaType });
  const limitedUrls = matchedUrls.slice(0, maxImages);

  setValue("imagesUrl", limitedUrls);
  onProductMatched();
};
